import React, { useContext, useEffect, useState } from 'react';

import { SkeletonLoader } from '../../SharedComponents/Loaders';
import { Context } from "../index";
import Place from "./Place";

import './index.sass';


const PlacesList = () => {

  const [descriptionWidth, setDescriptionWidth] = useState(0);

  const {
    dataLoaded,
    hoveredPlaceId,
    isLoading,
    mapIsOpen,
    places,
    setHoveredPlaceId,
  } = useContext(Context);


  useEffect(() => {
    window.addEventListener('orientationchange', handleDescriptionWidth);
    window.addEventListener('resize', handleDescriptionWidth);
    return () => {
      window.removeEventListener('orientationchange', handleDescriptionWidth);
      window.removeEventListener('resize', handleDescriptionWidth);
    }
  }, [places]);


  useEffect(() => {
    handleDescriptionWidth();
  }, [places, mapIsOpen]);


  const handleDescriptionWidth = () => {
    setTimeout(() => {
      if (places && places.length) {
        const placeId = places[0].attributes.id;
        const placeWrapper = document.getElementById(`place-${placeId}`);
        const wrapperWidth = placeWrapper && placeWrapper.offsetWidth;

        wrapperWidth && setDescriptionWidth(wrapperWidth);
      }
    }, 50);
  };

  const noResults = (!places || !places.length) && !isLoading && dataLoaded;


  return (
    <div className={`places-list ${mapIsOpen ? "with-map" : ""}${noResults ? ' empty' : ''}`}>

      { places && places.length >= 1
        ?
        places.map((elem, index) =>
            <Place
              hoveredPlaceId={hoveredPlaceId}
              descriptionWidth={descriptionWidth}
              place={elem.attributes}
              key={`${elem.attributes.id}-${index}`}
              setHoveredPlaceId={setHoveredPlaceId}
            />)
        :
          isLoading || !dataLoaded
        ?
          Array.apply('test', Array(12)).map((key, index) =>
            <SkeletonLoader className="places-list__loader" count={7} key={index} />
          )
        :
          <div className="places-list__no-results">
            <h3>Din søgning gav desværre ingen resultater</h3>
            <p>Vi har på nuværende tidspunkt ingen lokaler, der matcher din søgning. Prøv eventuelt at tilpasse din søgning og gør den bredere i forhold til kategori, antal af gæster, forplejning og beliggenhed.</p>
          </div>
     }

    </div>
  );
}

export default PlacesList;
